<template>
  <div class="upgrade-desc">
    <div class="content">
      <!-- <div class="img">
        <img src="../../assets/refundIntroPic.png" alt />
      </div>-->
      <p>1、目前该产品仅支持784国内客票同航班物理舱位升级，需在航班计划起飞2小时前进行办理。</p>
      <p>2、团队票、大客户票、里程兑换票、公务/职优票、政府采购票、礼遇票及国际客票暂时无法在线办理升舱；具体是否可以办理升舱，请以系统实际查询为准。</p>
      <p>3、升舱需收取一定的票价差，具体价格以系统实际计算/人工审核为准。</p>
      <p>4、升舱后自愿退票，按照升舱后舱位标准退升舱费，执行原客票退票规则；升舱后客票自愿变更，执行新票变更规则。</p>
      <p>5、升舱后权益：按照新舱位标准享受地面服务、空中服务、里程及升级航段累计。</p>
      <p>6、升舱成功后，可通过南航APP获取原客票及升舱差价电子发票。</p>
      <div class="btn-group">
        <van-button href="tel:95539" tag="a" round type="info" size="small">联系95539</van-button>
        <van-button @click="onClick" round type="info" size="small">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClick() {
      this.$popup.clear();
    }
  }
};
</script>


<style lang="less" scoped>
.content {
  overflow-y: scroll;
  max-height: 450px;
  > p {
    color: #000;
    opacity: 0.5;
    max-width: 240px;
    margin: 0 auto;
    line-height: 24px;
    font-size: 11px;
    text-align: left;
  }
}
.img {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  > img {
    width: 100px;
  }
}
.btn-group {
  margin-top: 20px;
  text-align: center;
  > button,
  > a {
    width: 42%;
    margin: 0 5px !important;
  }
}
</style>
